import api from './client';

// Scheduled Revolut payments made by the app after approval (ISS-ac0eeeeb, 2026-10-27)
export const revolutPaymentsAPI = {
  getStatus: () => api.get('/revolut-payments/status'),
  getSchedules: (params) => api.get('/revolut-payments/schedules', { params }),
  getPayments: (params) => api.get('/revolut-payments/payments', { params }),
  scheduleAction: (id, action) => api.post(`/revolut-payments/schedules/${id}/${action}`),
  removeTemporaryAmount: (id, overrideId) => api.delete(`/revolut-payments/schedules/${id}/temporary-amounts/${overrideId}`),
  retryPayment: (id) => api.post(`/revolut-payments/payments/${id}/retry`),
  check: () => api.post('/revolut-payments/check'),
};
